const LOGO_URL = "https://customer-assets-4nw71qhi.emergentagent.net/job_vapi-dashboard/artifacts/l70mxri7_d208e453-58ff-40e0-83dd-a7467d6c4b47.png";

export function CallSwiperLogo({ size = 28, showText = true, variant = "sidebar" }) {
  // Variant "sidebar": icon + wordmark, compact
  // Variant "stamp": bigger stacked logo (for login hero)
  if (variant === "stamp") {
    return (
      <div className="flex flex-col items-center gap-2" data-testid="callswiper-logo">
        <img
          src={LOGO_URL}
          alt="Call Swiper"
          className="dark:invert transition-none"
          style={{ height: size * 3, width: "auto" }}
        />
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2.5" data-testid="callswiper-logo">
      <div
        className="shrink-0 flex items-center justify-center rounded-md bg-foreground/[0.03] border border-border overflow-hidden"
        style={{ width: size + 12, height: size + 12 }}
      >
        <img
          src={LOGO_URL}
          alt="Call Swiper logo"
          className="dark:invert object-contain"
          style={{ width: size, height: size, objectFit: "contain" }}
        />
      </div>
      {showText && (
        <div className="flex flex-col leading-none">
          <span className="text-[15px] font-extrabold tracking-tight" style={{ fontFamily: "var(--font-heading)" }}>
            CALL SWIPER
          </span>
          <span className="text-[9px] uppercase tracking-[0.22em] text-muted-foreground mt-1">Zero Missed Calls</span>
        </div>
      )}
    </div>
  );
}
